import fetch from "auth/FetchInterceptor";

const SaleService = {};

SaleService.getSalesByCategory = function () {
  return fetch({
    url: "/sales-by-category/",
    method: "get",
  });
};

SaleService.getTopProducts = function () {
  return fetch({
    url: "/top-products/",
    method: "get",
  });
};

SaleService.getDashboardStats = function () {
  return fetch({
    url: "/dashboard-stats/",
    method: "get",
  });
};

SaleService.getMainDashboardStats = function () {
  return fetch({
    url: "/dashboard/",
    method: "get",
  });
};

SaleService.getSalesReport = function (params = {}) {
  return fetch({
    url: "/sales-report/",
    method: "get",
    params,
  });
};

export default SaleService;
